import React, { FC } from 'react';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

interface OrderStatusFilterProps {
    orderStatus: {
        name: string;
        label: string;
    };
    checked: boolean;
    onCheckStatus: (name: string, checked: boolean) => void;
}

const useStyles = makeStyles({
    filterButton: (checked: boolean) => ({
        backgroundColor: checked ? '#D32F3F' : 'white',
        color: checked ? 'white' : 'gray',
        borderRadius: '24px',
        margin: '0px 5px 0px 5px'
    })
});

//WIP for next user stories//
export const OrderStatusFilter: FC<OrderStatusFilterProps> = (props: OrderStatusFilterProps) => {
    const { orderStatus, onCheckStatus, checked } = props;
    const classes = useStyles(checked);

    const handleChange = (e: any) => {
        onCheckStatus(orderStatus.name, !checked);    
    }
    
    return (
        <Button
            value={orderStatus.name} 
            variant="contained" 
            className={classes.filterButton}
            onClick={handleChange}
        >
            {orderStatus.label}
        </Button>
    );
}
